export default "__VITE_ASSET__ohaiuPXS__"